import { Button, Card, Container, Grid } from "@mui/material"
import ArgonBox from "components/ArgonBox"
import { getDataWithResponse } from "global/getFunc"
import { useEffect, useState } from "react"

import logo_buton from "assets/images/logo-buton.png"
import ArgonTypography from "components/ArgonTypography"
import userStore from "store/userStore"

const TahunAnggaran = () => {
    const { setTahunAnggaran } = userStore((state) => ({ setTahunAnggaran: state.setTahunAnggaran }));
    const [loading, setLoading] = useState(false)
    const [listTA, setListTA] = useState([])

    useEffect(() => {
        reqTA()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqTA = () => {
        setLoading(true)
        getDataWithResponse(
            // `/admin-opd/perencanaan-opd/${decodedUser.tahun_anggaran}/${decodedUser.kd_pd}`,
            `/get-ta`,
            null,
            (res) => {
                console.log(res);
                setListTA(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        );
    }

    return (
        <Container>
            <Card
            sx={{
                minHeight: '100vh'
            }}
            >
                <ArgonBox py={15}>
                    <ArgonBox display='flex' justifyContent='center'>
                            <ArgonBox
                                component="img"
                                src={logo_buton}
                                alt="background"
                                width="200px"
                            />
                    </ArgonBox>
                    <ArgonBox display='flex' justifyContent='center'>
                        <Grid item>
                            <ArgonTypography
                                fontWeight='bold'
                                variant="inherit"
                            // color={cell.row.original.status === 'SubKegiatan' ? 'primary' : 'inherit'}
                            >
                                TEPRA Kab. Buton
                            </ArgonTypography>
                        </Grid>
                    </ArgonBox>
                    <ArgonBox display='flex' justifyContent='center' pt={3}>
                        <Grid item>
                            <ArgonTypography
                                fontWeight='bold'
                                fontSize="small"
                                variant="inherit"
                            // color={cell.row.original.status === 'SubKegiatan' ? 'primary' : 'inherit'}
                            >
                                TAHUN ANGGARAN
                            </ArgonTypography>
                        </Grid>
                    </ArgonBox>
                    <Grid container justifyContent='center' pt={2}>
                        <Grid item xs={6} lg={4} textAlign='center'>
                            {
                                listTA.map((ta, index) => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        key={index}
                                        sx={{
                                            m: .5,
                                            borderRadius: '50%',
                                            height: '70px',
                                            width: '70px'
                                        }}
                                        onClick={() => setTahunAnggaran(ta)}
                                    >
                                        {ta.ta}
                                    </Button>
                                ))
                            }
                        </Grid>
                    </Grid>
                </ArgonBox>
            </Card>
        </Container>
    )
}

export default TahunAnggaran